module.exports = __webpack_public_path__ + "img/logo.80d87318.png";